<template>
  <div id="applet" @click="hideDialog">
    <!-- 导航头部 -->
    <el-header>
      <div class="head">
        <div class="left">
          <div class="title">
            <div class="icon_box">
              <svg class="icon">
                <use
                  :xlink:href="
                    require('../assets/svg/app.svg?t=1662436280847') + '#logo'
                  "
                ></use>
              </svg>
            </div>
            <div class="box">
              <span>{{ itemName }}</span>
              <el-icon @click.stop="openDialog" v-if="false"
                ><CaretBottom
              /></el-icon>
            </div>
          </div>
        </div>
        <div class="right">
          <el-dropdown size="large" placement="bottom-end" trigger="click">
            <div>
              <el-avatar
                :size="32"
                :src="require('@/assets/images/user.png')"
              ></el-avatar>
              <span class="name">{{
                $store.state.userInfo ? $store.state.userInfo.realname : ""
              }}</span>
              <el-icon><CaretBottom /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  @click="this.$refs.routerBody.opendrawer('userInfo')"
                  ><el-icon><User /></el-icon>个人信息</el-dropdown-item
                >
                <el-dropdown-item @click="loginOut"
                  ><el-icon><SwitchButton /></el-icon>退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <!-- 主体 -->
    <el-container>
      <el-aside width="auto" :class="isCollapse ? 'hide' : ''">
        <el-scrollbar height="100%">
          <el-menu
            :default-active="url"
            class="el-menu-vertical-demo"
            active-text-color="#059669"
            :default-openeds="['/home']"
            @select="handleSelect"
            :collapse="screenWidth > 1200 ? isCollapse : false"
            :router="true"
          >
            <el-sub-menu
              :index="item.path"
              class="menu_item"
              v-for="item in routerArr"
              :key="item.path"
            >
              <template #title>
                <div class="icon_box">
                  <svg class="icon">
                    <use
                      :xlink:href="
                        require('../assets/svg/app.svg?t=1662436280847') +
                        (new RegExp(`^\/${item.pathName}`).test(url)
                          ? `#${item.icon}_active`
                          : `#${item.icon}`)
                      "
                    ></use>
                  </svg>
                </div>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="item2.path"
                  v-for="item2 in item.children"
                  :key="item2.path"
                  >{{ item2.name }}</el-menu-item
                >
              </el-menu-item-group>
            </el-sub-menu>
          </el-menu>
        </el-scrollbar>

        <div
          :class="'fold' + (screenWidth < 1200 && isCollapse ? ' hide' : '')"
          @click="collapse"
        >
          <el-icon v-show="!isCollapse"><Fold /></el-icon>
          <el-icon v-show="isCollapse"><Expand /></el-icon>
        </div>
      </el-aside>
      <el-main>
        <routerBody ref="routerBody"></routerBody>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import routerBody from "@/components/routerBody";
import router from "@/router";
import config from "@/utils/config";
export default {
  name: "app",
  components: {
    routerBody,
  },
  data() {
    return {
      //左侧导航栏选中下标
      url: "",
      //弹窗的展开收起状态
      show: false,
      //侧边导航栏折叠状态
      isCollapse: document.body.clientWidth < 1200 ? true : false,
      //项目名称
      itemName: window.config ? window.config.title || config.title || "智能物联 管理平台" : "智能物联 管理平台",
      //视口计时器
      timer: null,
      //视口宽度
      screenWidth: document.body.clientWidth,
      //路由数组
      routerArr: [],
    };
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        this.url = newVal.path.split("/").splice(0, 3).join("/");
      },
      immediate: true,
    },
    screenWidth: {
      handler(val, oldVal) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.$store.commit("setWidth", val);
      },
      deep: true,
    },
  },
  mounted() {
    window.onresize = () => {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        this.screenWidth = document.body.clientWidth;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          that.timer = false;
        }, 400);
      }
    };
    // 如果全局配置对象存在，设置项目名称
    if (window.config && window.config.title) {
      this.itemName = window.config.title;
    }
    this.$store.commit("setWidth", document.body.clientWidth);
    this.routerArr = this.routerFilter(this.$router.options.routes);
    if (this.$store.getters.getToken) this.$store.dispatch("aliveGet");
  },
  beforeMount() {},
  methods: {
    //菜单栏过滤
    routerFilter(arr = []) {
      let pages = this.$store.state.userInfo.pages || "";
      if (pages != "*") pages = pages.split(",");
      arr = this.$dataConver.deepClone(arr.filter((item) => item.pathName));
      arr = arr.filter((item) => {
        if (pages == "*") {
          return item.path;
        } else {
          return (
            item.path &&
            item.pages.some((page) => pages.find((page2) => page == page2))
          );
        }
      });
      arr.forEach((item) => {
        if (item.children && item.children.length)
          item.children = this.routerFilter(item.children);
      });
      return arr;
    },
    //选中侧边导航栏
    handleSelect(e) {
      // console.log("handleSelect", e);
      if (this.screenWidth <= 1200) {
        this.isCollapse = true;
      }
      this.$refs.routerBody.closedrawer();
      this.url = e;
    },
    //侧边导航栏折叠
    collapse(e) {
      this.isCollapse = !this.isCollapse;
    },
    pagesState(arr) {
      let pages = this.$store.state.pages ? this.$store.state.pages.pages : "*";
      if (pages && pages != "*") {
        pages = pages.split(",");
        let state = arr.some((item) => {
          let bool = pages.find((item2) => {
            return item == item2;
          });
          return bool;
        });
        return state;
      } else if (pages == "*") {
        return true;
      } else {
        return false;
      }
    },
    //退出登录
    loginOut() {
      this.$store.commit("setUser", { token: "" });
      router.replace({ path: "/login" });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/home.scss";
</style>